import styled from'styled-components';const MainTitle = styled.h3.withConfig({
  componentId: "sc-1iyav2j-0"
})(["", ""], props => props.theme.typography.mainTitle);export{MainTitle};//# sourceMappingURL=Typography.js.map
